<template>
    <div class="card" v-show="loaded">

        <div class="card-header border-0">
            <div class="row">
                <div class="col">
                    <h3 class="mb-0 text-uppercase">{{ $t('common.cohorts') }}</h3>
                </div>
            </div>
        </div>

        <p class="card-body pt-0 text-sm" v-if="empty">{{ $t('dashboard.no-cohort') }}</p>

        <div v-if="!empty">
            
            <table-control :paging="ctrl.paging" :search="true" v-model="search"></table-control>

            <base-checkbox class="mb-3 ml-3 d-inline-block" v-model="showArchives">
                {{ $t('cohorts.show-archived-classes') }}
            </base-checkbox>

            <el-table class="table-responsive table-flush"
                    :show-header="false"
                    :data="ctrl.rows">

                <el-table-column>
                    <template v-slot="{row}">
                        <h4 class="mb-0">
                            <a href="#" @click.prevent="open(row)">
                                {{row.name}}
                            </a>
                        </h4>
                        <small v-if="row.owner">
                            {{ row.owner.name }}
                        </small>
                    </template>
                </el-table-column>

                <el-table-column align="right" class-name="actions" width="120">
                    <template v-slot="{row}">
                        <div class="p-1">

                            <base-button type="primary" size="sm" @click="open(row)">
                                {{ $t('dashboard.follow-up') }}
                            </base-button>

                        </div>
                    </template>
                </el-table-column>
                
            </el-table>

            <table-pagination :paging="ctrl.paging"></table-pagination>
        </div>
    </div>
</template>

<script>
    import CrudController from '@trax/classes/CrudController'
    import CohortMapping from '../../accounts/cohorts/CohortMapping'

    export default {

        data() {
            let mapping = new CohortMapping()
            return {
                loaded: false,
                ctrl: new CrudController({
                    endpoint: '/astral/api/front/cohorts',
                    mapData: mapping.mapData,
                    unmapData: mapping.unmapData,
                    paging: {
                        perPage: 10,
                        total: 0
                    },
                    query: {
                        sort: ['name'],
                        relations: ['owner'],
                        filters: { myCohorts: true, showArchives: false }
                    }
                }),
                search: '',
                showArchives: false
            }
        },

        created() {
            this.ctrl.init(this, 'ctrl').then(resp => {
                this.loaded = true
            })
        },

        watch: {
            search(val) {
                this.ctrl.filterMore({ name: {$text: val} })
            },

            showArchives(val) {
                this.ctrl.filterMore({ showArchives: val })
            },
        },

        computed: {
            empty() {
                return this.ctrl.rows.length == 0 && !this.search
            },
        },

        methods: {            
            open(row) {
                this.$router.push({ name: 'dashboard-cohort', params: { cohortId: row.id } })
            }
        }
    }
</script>

<style scoped>

    .card >>> th,
    .card >>> td {
        padding-right: 0;
    }
    .card >>> th.actions,
    .card >>> td.actions {
        padding-left: 0rem;
        padding-right: 1.5rem;
    }
    .card >>> .table-control form {
        width: 100%;
    }

</style>
